import { useCallback } from 'react';
import useCreateOperation from './useCreateOperation';

const OPERATION_ERROR_MESSAGES = {
  INVALID_CERTIFICATE_PASSWORD:
    'La contraseña del certificado digital no es válida. Verifica e intenta de nuevo.',
  CERTIFICATE_ERROR:
    'Error con el certificado digital. Verifica tus credenciales.',
  DATE_TO_PAY_NOT_BUSINESS_DAY:
    'La fecha de pago debe ser un día hábil (no feriado ni fin de semana).',
};

const DEFAULT_OPERATION_ERROR_MESSAGE = 'Error al crear la operación. Intenta de nuevo.';

export const getOfferCartOperationErrorMessage = (error) => {
  const graphQLError = error?.graphQLErrors?.[0];
  if (!graphQLError) {
    return DEFAULT_OPERATION_ERROR_MESSAGE;
  }

  const code = graphQLError.extensions?.code;
  if (code && OPERATION_ERROR_MESSAGES[code]) {
    return OPERATION_ERROR_MESSAGES[code];
  }

  return DEFAULT_OPERATION_ERROR_MESSAGE;
};

const useSubmitOfferCartOperation = ({
  certificatePassword = '',
  isExternal = false,
}) => {
  const [createOperation] = useCreateOperation(
    isExternal, // isExternal
    undefined, // bankId
    undefined, // certificatePassword
    undefined, // onCompleted
    undefined, // setError
    true, // skipCleaning
  );

  const submitOperation = useCallback(({
    bankAccountId,
    digitalCertificatePassword: passwordOverride,
    onCompleted,
    onError,
  }) => {
    createOperation({
      variables: {
        ...(bankAccountId !== undefined ? { bankAccountId } : {}),
        digitalCertificatePassword: passwordOverride !== undefined
          ? passwordOverride
          : certificatePassword,
        isExternal,
      },
      onCompleted,
      onError: (error) => {
        if (onError) {
          onError(getOfferCartOperationErrorMessage(error), error);
        }
      },
    });
  }, [certificatePassword, createOperation, isExternal]);

  return { submitOperation };
};

export default useSubmitOfferCartOperation;
